import { render, staticRenderFns } from "./InformationDietCard.vue?vue&type=template&id=6234bd74&scoped=true&"
import script from "./InformationDietCard.vue?vue&type=script&lang=js&"
export * from "./InformationDietCard.vue?vue&type=script&lang=js&"
import style0 from "./InformationDietCard.vue?vue&type=style&index=0&id=6234bd74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6234bd74",
  null
  
)

export default component.exports